"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BarGroup = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var clsx_1 = __importDefault(require("clsx"));
var BAR_GROUP_STYLE = "flex flex-row my-0";
var BarGroup = function (_a) {
    var className = _a.className, children = _a.children;
    return ((0, jsx_runtime_1.jsx)("div", __assign({ className: (0, clsx_1.default)(BAR_GROUP_STYLE, className) }, { children: children }), void 0));
};
exports.BarGroup = BarGroup;
